module.exports = __webpack_public_path__ + "static/media/shopify.48d9ad9c.svg";